:root {
  color-scheme: dark;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root[data-theme='light'] { color-scheme: light; }

html, body, #root { min-height: 100%; }

html { background: #0b0c0d; }

body { margin: 0; min-width: 320px; }

img { max-width: 100%; }

button, input, textarea, select { font: inherit; }

:focus-visible { outline: 2px solid #c8ff35; outline-offset: 4px; }
